import { useState, useEffect } from 'react';
import Button from '../Button/Button';
import './Modal.scss'

export default function Modal({ text, children, callback, className, fn, isOpen = false }) {
    /**
     * Modal component that displays content in a modal dialog.
     * @param {string} text - Text to display on the modal button.
     * @param {ReactNode} children - Content to display inside the modal.
     * @param {function} callback - Function to call when the modal is closed.
     * @param {string} className - Additional CSS classes for the modal.
     */

    const [open, setOpen] = useState(isOpen);
    const [content, setContent] = useState(null);

    useEffect(() => {
        console.log('Modal isOpen prop changed:', isOpen);
        setOpen(isOpen);
    }, [isOpen]);

    async function open_modal() {
        if (!fn) {
            setOpen(true);
            return;
        }

        const res = await fn();
        setContent(<>
            {res}
        </>);
        setOpen(true);
    }

    function close() {
        setOpen(false);
        if (callback) {
            callback();
        }
    }
    return (
        <div className='modal-container'>
            {!isOpen && <Button text={text || 'Open Modal'} onClick={open_modal} class_="modal-button" />}
            {open && (
                <div className={`modal ${className || ''}`}>
                    <div className="modal-content">
                        <span className="close" onClick={close}><span className='material-icon material-button'>close</span></span>
                        {children}
                        {content}
                    </div>
                </div>
            )}
        </div>

    );
}